import React from "react";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  createStyles,
  Theme,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import { useQuery, gql } from "@apollo/client";

import AppBar from "@Components/appBar/appBar";
import TagChips, { TagData } from "@Components/posts/tagChips";
import HeaderBlock from "@Components/posts/headerBlock";
import Section from "@Components/posts/section";
import Footer from "@Components/common/footer";
import client from "@Config/graphCMSInit";
import SEO from "@Components/common/seo";
import DisplayAd from "@Components/ads/displayAd";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

export const GET_ALL_TAGS = gql`
  query GetTags {
    tags(orderBy: updatedAt_ASC) {
      name
      slug
      contentsWithTag {
        __typename
      }
    }
  }
`;

export const getStaticProps = async ({ locale }: any) => {
  const cmsQuery = await client.query({
    query: GET_ALL_TAGS,
  });

  return {
    props: {
      data: cmsQuery.data,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

interface StaticProps {
  data: { tags: TagData[] };
}

export default function Home({ data }: StaticProps) {
  const { t: t_common } = useTranslation("common");
  const classes = useStyles();
  const theme = useTheme();

  return (
    <React.Fragment>
      <SEO pageTitle="タグ一覧" />

      <AppBar>
        <Section>
          {data.tags ? (
            <React.Fragment>
              <HeaderBlock
                title={`タグ一覧: ${data.tags.length}件`}
                subtitle=""
              />

              <TagChips tags={data.tags} />

              <DisplayAd variant="in_article" />
            </React.Fragment>
          ) : null}
        </Section>

        <Footer />
      </AppBar>
    </React.Fragment>
  );
}
